import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { KaliteEditComponent } from './kalite-edit.component';
import { KaliteKartComponent } from './kalite-kart.component';
import { KaliteKartSadeComponent } from './kalite-kart-sade.component';

@DinamikBilesen({
  id: 'kalite',
  baslik: 'Kalite Kontrol',
  aciklama: 'Kalite kontrol formu',
  ikon: 'safety-certificate',
  kategori: 'uretim',
})
class Kalite {
  paylas_kutusu = KaliteEditComponent;
  paylasilmis_kart = KaliteKartComponent;
  paylasilmis_kart_sade = KaliteKartSadeComponent;
  hesaplamalar = {
    pipeline: [
      { $match: { _uid: '{{kartId}}', silindi: { $ne: true } } },
      { $lookup: { from: 'hareketler', localField: 'veri.icerikler', foreignField: '_id', as: 'icerikDetay' } },
      { $unwind: { path: '$icerikDetay', preserveNullAndEmptyArrays: false } },
      { $group: {
        _id: null,
        toplam: { $sum: 1 },
        uygun: { $sum: { $cond: [{ $eq: ['$icerikDetay.ek.sonuc', 'Uygun'] }, 1, 0] } },
        uygunsuz: { $sum: { $cond: [{ $eq: ['$icerikDetay.ek.sonuc', 'Uygun Degil'] }, 1, 0] } },
        ortalamaOlcu: { $avg: { $ifNull: ['$icerikDetay.ek.olcuDeger', 0] } }
      }}
    ]
  };
}
